import React from 'react'
import PropTypes from "prop-types";
import { round, shortenNumber, toExcelNumberFormatWithDecimals } from '../../../../utils/format';
import { Popup } from 'semantic-ui-react';
import { chartHeight } from "../../../../utils/constants"

export const BarValues = ( {drawData, decimalsNumber}) => {

  const { x, y, width, height, value } = drawData
    const longNumber = round(value, decimalsNumber)
    const shortNumber = shortenNumber(longNumber, 4)
    const popupContent = toExcelNumberFormatWithDecimals(longNumber, undefined, decimalsNumber)
    const renderText = ()=> {
      return(
              <text
                x={x + width / 2}
                y={y + 5 + height / 2}
                textAnchor="middle"
                alignmentBaseline="central"
                z={1}
                className={"zoneValue"}
              >
                {height > (1 / 12) * chartHeight
                  ? shortNumber
                  : null}
              </text>
      )
    }

    return(
      typeof(shortNumber) === 'string' && shortNumber.indexOf('...') > 0
        ?  <Popup
              on='hover'
              position="right center"
              content={popupContent}
              trigger={renderText()}
            />
        : renderText()

    )
  };

  BarValues.propTypes = {
    drawData: PropTypes.object,
    language: PropTypes.string,
    decimalsNumber: PropTypes.number

  }

  export default BarValues
